import React from 'react';

import { Col, Flex, Image, Row, Space, Typography } from 'antd';

interface IProps {
  children: React.ReactNode;
}

const PublicLayout = ({ children }: IProps) => (
  <Row className='min-h-screen'>
    <Col lg={8} md={11} sm={24} xs={24}>
      <Flex className='min-h-screen p-10 max-sm:p-5' vertical justify='space-between' gap='large'>
        <Flex vertical gap='large'>
          <Flex justify='center'>
            <Image alt='Logo do MyEduzz' preview={false} src='/img/logo.svg' width={220} />
          </Flex>
          {children}
        </Flex>

        <Flex vertical align='center'>
          <Typography.Text type='secondary' className='block px-0 py-5 text-center text-xs'>
            {new Date().getFullYear()} © Eduzz – Todos os direitos reservados
          </Typography.Text>
          <Space split={<Typography.Text type='secondary'>-</Typography.Text>} wrap>
            <Typography.Link href='https://eduzz.com/termos/' target='_blank'>
              Termos de Uso
            </Typography.Link>
            <Typography.Link href='https://eduzz.com/privacidade/' target='_blank'>
              Políticas de Privacidade
            </Typography.Link>
            <Typography.Link href='https://eduzz.com/frontend/institucional/contact' target='_blank'>
              Contato
            </Typography.Link>
          </Space>
        </Flex>
      </Flex>
    </Col>
    <Col lg={16} md={13} sm={0} xs={0} className='bg-surface-subtle' />
  </Row>
);

export default PublicLayout;
